// extracted by mini-css-extract-plugin
module.exports =  {"container":"_33974c2b58--container--E9Y0s","icon":"_33974c2b58--icon--BjqRR","name":"_33974c2b58--name--KsQFh"};